export default class TypeUtils {

  public static hasEnumOrDefault<T>(value: unknown, enumType: { [key: string]: any }, defaultValue = null): T | null {
    const found = Object.keys(enumType).find(v => enumType[v] === value);
    if (found) {
      return enumType[found];
    }
    return defaultValue;
  }

  public static hasIntegerOrDefault(value: unknown, defaultValue = null): number | null {
    if (value !== null && value !== undefined) {
      try {
        return Number.parseInt(value as string, 10);
        // eslint-disable-next-line no-empty
      } catch (ignored) {
      }
    }
    return defaultValue;
  }

  public static hasStringOrDefault(value: unknown, defaultValue = null): string | null {
    if (value) {
      return (value as { toString(): string }).toString();
    }
    return defaultValue;
  }

  public static hasBooleanOrDefault(value: unknown, defaultValue = false): boolean | null {
    if (value === null || value === undefined) {
      return defaultValue;
    } else if (typeof value === "boolean") {
      return value;
    } else if (typeof value === "string" && value === "true") {
      return true;
    }
    return defaultValue;
  }

  public static hasDateOrDefault(value: unknown, defaultValue = null): Date | null {
    if (value !== null && value !== undefined) {
      if (typeof value === "string") {
        try {
          return new Date(value);
        } catch (e) {
          return defaultValue;
        }
      }
      return value as Date;
    }
    return defaultValue;
  }

  public static hasObjectOrDefault<T>(value: T | any, defaultValue: null | T = null): T | null {
    if (!value || typeof value !== "object") {
      return defaultValue;
    }
    return value;
  }

  public static hasArrayOrDefault(value: unknown, defaultValue: null | any[] = null): any[] | null {
    if (value && Array.isArray(value)) {
      return value;
    }

    return defaultValue;
  }

  public static hasNumberOrDefault(value: unknown, defaultValue = 0.0): number | null {
    if (value !== null && value !== undefined) {
      return Number.parseFloat(value as string);
    }
    return defaultValue;
  }
}
